import React from 'react';
import cn from 'classnames';

import { ReactComponent as DecrementButton } from '../../assets/icons/ico_less_button.svg';
import { ReactComponent as IncrementButton } from '../../assets/icons/ico_more_button.svg';

import './counter.field.scss';

const CounterField = ({
	field: { name, value },
	form: { setFieldValue },
	className,
	minimum,
	maximum,
	handleChange,
	...props
}) => {
	function increment() {
		if (value >= maximum) return;

		setFieldValue(name, value + 1);
		if (handleChange) {
			handleChange();
		}
	}

	function decrement() {
		if (value <= minimum || value <= 0) return;

		setFieldValue(name, value - 1);
		if (handleChange) {
			handleChange();
		}
	}

	if(value > maximum){
		setFieldValue(name, maximum);
		if (handleChange) {
			handleChange();
		}
	}

	return (
		<div {...props} className={cn('counter', className)}>
			{DecrementButton && (
				<DecrementButton
					className={cn('counter-button', { disabled: value <= minimum || value <= 0 })}
					onClick={decrement}
				/>
			)}
			<span className="counter-value">{value}</span>
			{IncrementButton && (
				<IncrementButton
					className={cn('counter-button', { disabled: value >= maximum })}
					onClick={increment}
				/>
			)}
		</div>
	);
};

export default CounterField;
